"use client";

import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { QUERIES } from "@/config/queries";
import { useAuth } from "@/providers/AuthProvider";

interface PrefetchedQueriesProps {
    children: React.ReactNode;
}

export default function PrefetchedQueries({
    children,
}: PrefetchedQueriesProps) {
    const queryClient = useQueryClient();

    const { user } = useAuth();

    // Prefetch queries on app start
    useEffect(() => {
        if (!user) {
            return;
        }

        Object.entries(QUERIES)
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .sort(([queryNameA, queryA], [queryNameB, queryB]) => {
                return (queryA?.priority ? 0 : 1) - (queryB?.priority ? 0 : 1);
            })
            .forEach(([queryName, query]) => {
                if (query?.shouldPrefetch) {
                    queryClient
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        .prefetchQuery(query.query as any)
                        .catch((err) => {
                            console.warn(
                                `Failed to prefetch ${queryName}:`,
                                err
                            );
                        });
                }
            });
    }, [queryClient, user]);

    return children;
}
